<div [ngClass]="Theme">
    <ng-content select="[body-content]"></ng-content>
</div>